module.exports = __webpack_public_path__ + "img/teacherTrain-1.161b2939.png";